import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import PieContext from "../../PieContext";
import { appSettings } from "../../utils/endpoints";
import "../styles/Footer.styles.scss";

const Footer = () => {
  const [isMounted, setIsMounted] = useState(false);
  const [API_URL, setApiURL] = useState("");
  const [visitas, setVisitas] = useState(0);
  
  useEffect(() => {
    setIsMounted(true);
    appSettings.then(res => {
      setApiURL(res.API_URL);
    });
  }, []);

  useEffect(() => {
    if(isMounted && API_URL.length > 0){
      if(localStorage.getItem("Visita") === null)
        axios.get(`${API_URL}/Estadistica/UpdateVisitas`);

      axios.get(`${API_URL}/Estadistica/ConsultaVisitas`)
        .then(r => {
          setVisitas(r.data);
          localStorage.setItem("Visita","1")
        });
    }
  }, [isMounted, API_URL]);

  return (
    <>
      <div className="footerWrapper">
        <div className="footerSection">
          <div className="footerElement"></div>
        </div>
        <div className="footerSection">
          <div className="footerElement">
            Tribunal Electoral del Poder Judicial de la Federación (TEPJF)
            <br />
            Teléfonos 55-5728-2300 y 55-5484-5410. <br /> Todos los derechos
            reservados. <br /><br />
            Protección de datos personales <br /> Para su correcta
            visualización, se recomienda utilizar Google Chrome o Microsoft Edge<br/>
            {`Número de visitas: ${visitas}`}
          </div>
        </div>
        <div className="footerSection"></div>
      </div>
    </>
  );
};

export default Footer;
